export default function ContactSection() {
  return (
    <section id="contact" className="w-full py-16 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="max-w-2xl mx-auto text-center">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-900 mb-4">投稿爆料</h2>
          <p className="text-foreground-600 mb-8 leading-relaxed">
            有最新吃瓜线索或独家视频？欢迎通过以下方式联系我们。
            你的每一条投稿都可能成为全网热门话题，最快10分钟审核上线。
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <div className="flex items-center gap-3 px-6 py-4 bg-background-50 rounded-xl flex-1 w-full sm:w-auto">
              <div className="w-10 h-10 flex items-center justify-center">
                <i className="ri-mail-line text-2xl text-primary-500"></i>
              </div>
              <div className="text-left">
                <p className="text-xs text-foreground-500">投稿邮箱</p>
                <p className="text-sm font-medium text-foreground-800">tougao@91chigua.com</p>
              </div>
            </div>
            <div className="flex items-center gap-3 px-6 py-4 bg-background-50 rounded-xl flex-1 w-full sm:w-auto">
              <div className="w-10 h-10 flex items-center justify-center">
                <i className="ri-wechat-line text-2xl text-accent-500"></i>
              </div>
              <div className="text-left">
                <p className="text-xs text-foreground-500">微信客服</p>
                <p className="text-sm font-medium text-foreground-800">91chiguaVIP</p>
              </div>
            </div>
          </div>
          <a
            href="#contact"
            className="inline-flex items-center gap-2 mt-8 px-6 py-3 rounded-full bg-primary-500 text-white font-medium text-sm hover:bg-primary-600 transition-colors duration-200 whitespace-nowrap cursor-pointer"
          >
            <i className="ri-send-plane-line"></i>
            立即投稿
          </a>
        </div>
      </div>
    </section>
  );
}